import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

function MerchantLogo1xbet({ name, slug, width, height }) {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(false);
  }, [slug]);

  if (isError) {
    return <span className="text-white font-semibold">{name}</span>;
  }

  return (
    <img
      alt={name || ""}
      className="absolute left-5"
      style={{ width: width || "auto", minHeight: height }}
      onError={() => setIsError(true)}
      src={`/images/merchant/${slug}.svg`}
      title={name || ""}
    />
  );
}

MerchantLogo1xbet.propTypes = {
  name: PropTypes.string,
  slug: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default MerchantLogo1xbet;
